import footerCss from '#srcCssModules/footer/footer.module.scss';
import { FooterLinks } from '#base/components/footer/links';
import { useBaseContext } from '#base/hooks/use-base-context';
import { FooterPaymentIconList } from '#base/components/footer/payment-icon-list/FooterPaymentIconList';

const Footer = () => {
  const { footerLinks } = useBaseContext();

  if (footerLinks.length === 0) {
    return null;
  }

  return (
    <div className={footerCss.footer}>
      <FooterLinks />
      <FooterPaymentIconList />
    </div>
  );
};

export { Footer };
